import React, { Component } from 'react';
import moment, { min } from 'moment';
import { Typography, PageHeader, Button, Tooltip, Space, Card, Alert, Divider, Image, Modal, Input } from 'antd';
import { Redirect } from 'react-router-dom';
import {
  PauseCircleOutlined,
  PlayCircleOutlined,
  SecurityScanOutlined,
  ShopOutlined,
} from '@ant-design/icons';
import firebase from 'firebase';

import StrikeAccountTransactionsModel from '../../../models/StrikeAccountTransactionsModel';
import { isTestModeOn } from '../../../utils/testMode';
import StrikeClientRecentActivitiesModel from '../../../models/StrikeClientRecentActivitiesModel';
import StrikeClientActivitiesModel from '../../../models/StrikeClientActivitiesModel';
import StrikeClientModel from '../../../models/StrikeClientModel';
import BankAccountsModel from '../../../models/BankAccountsModel';
import StrikeWithdrawalsModel from '../../../models/StrikeWithdrawalsModel';
import { AccountBalancesView, ActionsButtonsCard, PauseButton } from '../../../components/client/AccountProfileComponents';
import ClientAvatar from '../../../components/client/ClientAvatar';
import SkuCardView from '../../../components/client/SkuCardView';
import TrackerService from '../../../utils/TrackerService';
import { countryFlags } from '../../../utils/CurrencyUtils';
import { RecentActivitiesTable } from '../../../components/client/RecentActivitiesComponents';
import CenteredSpinner from '../../../components/CenteredSpinner';
import { IDVTable, AdminSourcingBox, AdminChangeHistoryBox } from '../../../components/admin/AdminClientsComponents';
import TeamClientTeamCard from '../../../components/admin/TeamClientTeamCard';
import BannerAd from '../../../components/client/BannerAd';
import { ClientRecentAvailableActivityList } from '../../../components/client/TeamProfileRecentActivityList';
import { ProgressCreatingTap } from '../../../components/client/ProgressCreatingTap';
import { LoadableTeamsGrid } from '../../../components/client/LoadableTeamsGrid';
import { DelegatedClientsGrid } from '../../../components/client/DelegatedClientsGrid';
import { FormerTeamsSection } from '../../../components/client/FormerTeamsSection';
import { AnnouncementsCard } from '../../../components/client/AnnouncementList';
import { ClientAnnouncementsCard } from '../../../components/client/ClientAnnouncementList';
import ProfileCompletionAlert from '../../../components/client/ProfileCompletionAlert';
import FasterSigninCard from '../../../components/client/FasterSigninCard';
import HomeScreenCard from '../../../components/client/HomeScreenCard';
import { payoutDetailsMissing } from '../../../components/client/PayoutDetailsForm';
import BuyTippingStandsSection from '../../../components/client/BuyTippingStandsSection';
import { AdminGridClientConnectAccounts } from '../../../components/admin/AdminGridClientConnectAccounts';

import '../../../App.scss';
import 'antd/dist/antd.css';

const { Paragraph, Text } = Typography;

const isTest = window.location.hostname === 'localhost';

const STRIPE_DASHBOARD_TEST_APPS = 'https://dashboard.stripe.com/test/apps';
const STRIPE_DASHBOARD_LIVE_APPS = 'https://dashboard.stripe.com/apps';

// /client/manage/profile
export default class AccountProfileScreen extends Component {
  constructor(props) {
    super(props);

    const clientId = this.props.match.params.clientId;
    this.baseURLs = props.baseURLs || {
      manage: '/client/manage',
      login: '/client/login'
    };

    const isAdmin = !!props.isAdmin;

    this.clientModel = new StrikeClientModel({
      onClientFound: this.foundClient,
      onClientNotFound: this.clientNotFound,
      viewModel: this,
      clientId,
      isAdmin,
    });
    this.accountsModel = new StrikeAccountTransactionsModel({
      isTestMode: isTestModeOn(clientId),
      callback: this.updatedDataSource,
      viewModel: this,
      clientId
    });

    this.clientId = clientId;
    this.isAdmin = isAdmin;
    /** @type {(() => void) | null} */
    this.stripeAppsUnsubscribe = null;
    this.bankModel = new BankAccountsModel({ viewModel: this, clientId });
    this.withdrawalsModel = new StrikeWithdrawalsModel({ viewModel: this, clientId, limit: 10, dateFilterDays: 7, isTestMode: isTestModeOn(clientId) });
    this.clientRecentActivitiesModel = new StrikeClientActivitiesModel({ clientId, onUpdate: this.updatedRecentActivitiesDataSource, isTestMode: isTestModeOn(clientId) });

    this.state = {
      clientNotFound: false,
      route: null,
      showTestAccounts: true,
      user: null,
      client: null,
      clientId: clientId,
      accounts: [],
      recentActivities: [],
      tags: [],
      payouts: [],
      withdrawals: [],
      percent: 0,
      skus: [],
      showSkusComponent: false,
      loadingDetails: {
        user: false,
        client: true,
        accounts: false,
        transactions: false,
        actions: false,
      },
      showDates: false,
      showDatesCTA: 'Show Dates',
      isAdmin,
      isNewLayout: true,
      screenWidth: typeof window !== 'undefined' ? window.innerWidth : 1024,
      showPauseReasonModal: false,
      pauseReasonValue: '',
      /** @type {Array<{ id: string, appId?: string, platform?: string, is_test?: boolean, accountId?: string | null, status?: string }>} */
      clientStripeApps: [],
    };
  }

  componentDidMount() {
    this.clientModel.waitForClientData();
    this.handleResize = () => {
      this.setState({ screenWidth: window.innerWidth });
    };
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    if (this.stripeAppsUnsubscribe) {
      this.stripeAppsUnsubscribe();
      this.stripeAppsUnsubscribe = null;
    }
    if (this.accountsModel) this.accountsModel.stop();
    if (this.clientModel) this.clientModel.stop();
    if (this.clientRecentActivitiesModel) this.clientRecentActivitiesModel.stop();
    if (this.bankModel) this.bankModel.stop();
    if (this.withdrawalsModel) this.withdrawalsModel.stop();
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize);
    }
  }

  componentDidUpdate() {
  }

  isLoading = () => {
    return this.state.loadingDetails.user ||
      this.state.loadingDetails.client ||
      this.state.loadingDetails.accounts ||
      this.state.loadingDetails.actions ||
      false;
  }

  subscribeClientStripeApps = (clientId) => {
    if (this.stripeAppsUnsubscribe) {
      this.stripeAppsUnsubscribe();
      this.stripeAppsUnsubscribe = null;
    }
    const db = firebase.firestore();
    const ref = db.collection('clients').doc(clientId).collection('apps');
    this.stripeAppsUnsubscribe = ref.onSnapshot(
      (snapshot) => {
        const apps = snapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter(
            (a) => a.platform === 'stripe' && (!a.status || a.status === 'active'),
          );
        this.setState({ clientStripeApps: apps });
      },
      () => {
        this.setState({ clientStripeApps: [] });
      },
    );
  };

  foundClient = async (client) => {
    const isNewLayout = true;

    this.subscribeClientStripeApps(this.clientId);

    this.setState(
      (state) => {
        return {
          clientNotFound: false,
          client,
          loadingDetails: {
            client: false,
          },
          loadingPauseAction: false,
          isNewLayout,
        }
      }
    );

    const { isCompany } = client || { isCompany: false };

    // this.clientRecentActivitiesModel.start();
    this.accountsModel.waitForAccountsData();
    this.withdrawalsModel.waitForWithdrawlsData();
    this.bankModel.fetchAllPayoutsData(this.isAdmin);
  }


  clientNotFound = () => {
    if (this.stripeAppsUnsubscribe) {
      this.stripeAppsUnsubscribe();
      this.stripeAppsUnsubscribe = null;
    }
    this.setState({
      clientNotFound: true,
      clientStripeApps: [],
    });
  }

  foundAccounts = async (accounts) => {

    this.setState(
      (state) => {
        return {
          clientNotFound: false,
          accounts,
          loadingDetails: {
            accounts: false,
          }
        }
      }
    );
  }

  updatedDataSource = async (txns) => {
    const accounts = this.accountsModel.accounts;
    let transactions = this.accountsModel.transactions;


    this.setState(
      (state) => {
        return {
          clientNotFound: false,
          accounts,
          transactions,
        }
      }
    );
  }

  updatedTags = async (tags) => {

    let tippingTag = null;
    let paymentTag = null;

    tags.forEach(
      (v, i, a) => {
        const { product } = v;
        if (tippingTag == null && product === 'tipping') {
          tippingTag = v;
        }
        if (paymentTag == null && product === 'payment') {
          paymentTag = v;
        }
      }
    );

    this.setState(
      {
        tags,
        tippingTag,
        paymentTag,
      }
    );
  }

  updatedSkus = async (skus) => {
    let showSkusComponent = (skus.length > 0);
    let skuIndex = null;
    let sku = null;

    if (showSkusComponent) {
      showSkusComponent = false;
      skus.forEach((iSku, i) => {
        if (!showSkusComponent) {
          sku = iSku;
          showSkusComponent = sku && sku.countOffers < 1;
          skuIndex = i;
        }
      });
    }

    this.setState(
      (state) => {
        return {
          skus,
          sku,
          skuIndex,
          showSkusComponent
        }
      }
    );
  }

  updatedPayoutsDataSource = (payouts) => {
    this.setState(
      (state) => {
        return {
          payouts,
          loadingPayouts: false,
        }
      }
    );
  }

  updatedWithdrawalsDataSource = (withdrawals) => {
    this.setState(
      (state) => {
        return {
          withdrawals,
          loadingWithdrawals: false,
        }
      }
    );
  }

  updatedRecentActivitiesDataSource = async (data) => {
    let recentActivities = data;

    this.setState(
      (state) => {
        return {
          clientNotFound: false,
          recentActivities
        }
      }
    );
  }

  getProfileErrors = () => {
    const errors = [];
    const { client } = this.state;
    
    if (!client) return errors;
    
    // Check for missing required fields
    // Note: country can be null for older accounts (they're all IE anyway), so we don't require it when viewing
    if (!client.displayName) errors.push('Full name is missing');
    if (!client.phoneNumber) errors.push('Phone number is missing');
    
    // Check for invalid name format (non-company)
    if (!client.isCompany && client.displayName) {
      const words = client.displayName.trim().split(/\s+/).filter(word => word.length > 0);
      const hasLetterPattern = /[a-zA-Z]/;
      if (words.length < 2 || !words.every(word => hasLetterPattern.test(word))) {
        errors.push('We need your first and last name');
      }
    }
    
    // Check for age requirement (non-company)
    if (!client.isCompany && client.dob) {
      const dobMoment = client.dob;
      const today = moment();
      const age = today.diff(dobMoment, 'years', true);
      if (age < 13) {
        errors.push('You must be at least 13 years old');
      }
    }
    return errors;
  };

  // Date of birth and SSN last 4 are payout-account details (Stripe needs them
  // to pay out), not profile ones. Asked on the Payouts screen before the first
  // bank account; prompted here only once there is money to pay.
  getPayoutErrors = () => {
    const errors = [];
    const { client, accounts } = this.state;
    if (!client) return errors;
    const missing = payoutDetailsMissing(client, accounts);
    if (missing.dob) errors.push(client.isCompany ? 'Founded on is missing' : 'Date of birth is missing');
    if (missing.idLast4) errors.push('We need the last 4 digits of your SSN');
    if (client.idLast4 && !/^\d{4}$/.test(client.idLast4)) {
      errors.push('SSN last 4 must be exactly four digits');
    }
    return errors;
  };

  hasAnyBalance = () => (this.state.accounts || []).some((acc) => (acc && acc.available > 0));

  renderCompletionAlert = ({ title, items, footerText, page }) => {
    const base = this.baseURLs.manage || '/client/manage';
    return (
      <div style={{ paddingBottom: '16px', paddingTop: '16px' }}>
        <ProfileCompletionAlert
          title={title}
          items={items}
          footerText={footerText}
          variant="success"
          closable
          onClick={() => { window.location.href = `${base}/${this.state.clientId}/${page}`; }}
        />
      </div>
    );
  };


  handlerActionsButton = (selection) => {
    this.setState(
      {
        route: selection.route,
        subroute: selection.subroute,

      }
    );
  }

  onSelectOpenPDP = () => {
    const route = `order/${this.state.sku.id}`;

    this.trackOrderState('offer_clicked', {
      skuId: this.state.sku.skuId,
      name: this.state.client.displayName,
      clientId: this.state.clientId,
    });

    this.setState(
      {
        route,
        skus: null,
        skuIndex: null,
        sku: null,
        showSkusComponent: false,
      }
    );
  }

  onSelectSKU = (sku, skuIndex) => {
    this.trackOrderState(
      'offer_impression',
      {
        clientId: this.state.clientId,
        name: this.state.client.displayName,
        skuId: sku.skuId,
      }
    );

    this.setState(
      {
        sku,
        skuIndex
      }
    );
  }

  renderRedirect = () => {
    const { route, subroute } = this.state;
    const clientId = this.props.match.params.clientId;
    if (route && clientId) {
      const fromRoute = `${this.baseURLs.manage}/${clientId}`;
      let toRoute = `${this.baseURLs.manage}/${clientId}/${route}`;
      if (subroute) toRoute = `${toRoute}/${subroute}`;
      return <Redirect push to={toRoute} />
    } else {
      return null;
    }
  }

  trackOrderState = (eventId, data) => {
    const isTest = window.location.hostname === 'localhost';

    const tracker = new TrackerService({
      isTest,
    });

    tracker.mixpanelTrack(eventId, { ...data });
    tracker.googleTrack(eventId, { ...data });

  }

  navigateToKycVerification = () => {
    this.setState(
      {
        route: 'idverification'
      }
    );
  }

  isKycButtonShown = () => {
    return this.state.client && this.state.client.idVerificationAllowed
      && ((this.state.client.idVerificationStatus === '') || (this.state.client.idVerificationStatus !== 'rejected'));
  }

  handlerPauseClient = () => {
    this.setState({ showPauseReasonModal: true, pauseReasonValue: '' });
  };

  doPauseOrEnable = async (remarks) => {
    this.setState({ loadingPauseAction: true, showPauseReasonModal: false });
    await this.clientModel.pauseOrEnableClient({ remarks: remarks || null });
    this.setState({ loadingPauseAction: false, pauseReasonValue: '' });
  };

  isClientTypeTeam = (clientType) => {
    return clientType === 'team';
  }

  /** Shown only when `clients/{clientId}/apps` has active Stripe platform docs (from strike-payer OAuth). */
  renderStripeAppsPanel = () => {
    const { clientStripeApps } = this.state;
    if (!clientStripeApps || clientStripeApps.length === 0) {
      return null;
    }

    return (
      <div style={{ paddingBottom: 16, paddingTop: 8 }}>
        <Alert
          type="info"
          showIcon
          message="Stripe apps"
          description={(
            <div>
              <Paragraph type="secondary" style={{ marginBottom: 12 }}>
                This account is linked from the Stripe Dashboard. Open Apps in Stripe to use your installed app
                (e.g. Striketip).
              </Paragraph>
              {clientStripeApps.map((app) => {
                const testMode = !!app.is_test;
                const href = testMode ? STRIPE_DASHBOARD_TEST_APPS : STRIPE_DASHBOARD_LIVE_APPS;
                const label = testMode ? 'Open Stripe (test — Apps)' : 'Open Stripe (live — Apps)';
                const appLabel = app.appId || 'Stripe app';
                return (
                  <div key={app.id} style={{ marginBottom: 12 }}>
                    <Paragraph style={{ marginBottom: 8 }}>
                      <Text strong>{appLabel}</Text>
                      <Text type="secondary">{testMode ? ' · Test mode' : ' · Live mode'}</Text>
                      {app.accountId ? (
                        <Text type="secondary">{` · Account ${app.accountId}`}</Text>
                      ) : null}
                    </Paragraph>
                    <Button type="primary" href={href} target="_blank" rel="noopener noreferrer">
                      {label}
                    </Button>
                  </div>
                );
              })}
            </div>
          )}
        />
      </div>
    );
  };

  render() {
    const avatar = <ClientAvatar client={this.state.client} />
    const avatarParams = { src: avatar };
    const redirected = this.renderRedirect();

    if (redirected) {
      return redirected;
    }

    const isRestricted = this.state.client && this.state.client.isRestricted;
    const isAdmin = this.props && this.props.isAdmin;

    const pauseButton = <PauseButton
      isLoading={this.state.loadingPauseAction}
      isRestricted={isRestricted}
      pauseHandler={this.handlerPauseClient}
      key='2'
    />


    let teamsAllowedButton = null;

    let buttonText = 'Remove Teams';
    let tooltipText = 'Client will lose Teams Access';

    const { client } = this.state;

    // Phone is a login method only if the Firebase Auth record carries a phone credential
    // matching the profile number (mirrors the "Verify →" logic on the profile edit screen).
    // client.authProviders is an unreliable mirror, so read the auth record directly.
    const authUser = firebase.auth().currentUser;
    const authPhone = authUser ? authUser.phoneNumber : null;
    const clientPhone = client && client.phoneNumber;
    const phoneIsLoginMethod = !!authPhone && authPhone === clientPhone;
    const isMobile = this.state.screenWidth <= 768;

    const { isShowAds, country, type: clientType } = client || {};
    const flag = country ? countryFlags[country] : '';
    const teamAccountText = this.isClientTypeTeam(clientType) ? '(Team Account)' : '';

    if (isAdmin && !this.isClientTypeTeam(clientType)) {
      let icon = <PauseCircleOutlined />;

      if (this.state.client && !this.state.client.teamsAllowed) {
        buttonText = 'Allow Teams';
        icon = <PlayCircleOutlined />;
        tooltipText = 'Client will get Teams Access';
      }

      teamsAllowedButton =
        <Tooltip title={tooltipText} key='4'>
          <Button icon={icon} onClick={() => handleTeamsAccessChange()} type="secondary" danger={buttonText === 'Remove Teams'}>
            {buttonText}
          </Button>
        </Tooltip>;
    }

    const handleTeamsAccessChange = async () => {
      const db = firebase.firestore();

      await db.collection('clients').doc(this.state.clientId).update({
        teamsAllowed: buttonText === 'Allow Teams'
      })
    }


    let rejectKYCButton = null;

    if (isAdmin && this.state.client && this.state.client.idVerificationAllowed) {
      if ((this.state.client.idVerificationStatus == null)
        || (this.state.client.idVerificationStatus && (this.state.client.idVerificationStatus !== 'rejected'))) {
        let kycButtonText = 'Reject KYC';
        let icon = <PauseCircleOutlined />;
        let kycTooltipText = 'Client will have KYC Verification status set to REJECTED';

        rejectKYCButton =
          <Tooltip title={kycTooltipText} key="6">
            <Button icon={icon} onClick={() => rejectKYC()} type="secondary" danger={true}>
              {kycButtonText}
            </Button>
          </Tooltip>;
      } else {
        rejectKYCButton =
          <Tooltip title={'KYC is already REJECTED'} key='5'>
            <Button type="secondary" danger={true} color={'maroon'}>
              KYC REJECTED
            </Button>
          </Tooltip>;
      }
    }

    const rejectKYC = async () => {
      const db = firebase.firestore();

      await db.collection('clients').doc(this.state.clientId).update({
        idVerificationStatus: 'rejected',
        updatedAt: firebase.firestore.Timestamp.now()
      });

      let idVerificationDocSnapshot = await db.collection('clients').doc(this.state.clientId).collection('idVerifications').get();

      if (!idVerificationDocSnapshot.empty) {
        const idVerificationDocSnapshotId = idVerificationDocSnapshot?.docs[0].id;
        await db.collection('clients').doc(this.state.clientId).collection('idVerifications').doc(idVerificationDocSnapshotId).set({
          status: 'rejected',
          rejectedAt: firebase.firestore.Timestamp.now(),
          updatedAt: firebase.firestore.Timestamp.now()
        }, {merge : true});
      } else {
        await db.collection('clients').doc(this.state.clientId).collection('idVerifications').add({
          clientId: this.state.clientId,
          email: this.state.client.email ? this.state.client.email : null,
          uuid: null, //because verification was never initiated for this client - as KYC was rejected even before he could initiate KYC
          status: 'rejected',
          rejectedAt: firebase.firestore.Timestamp.now(),
          createdAt: firebase.firestore.Timestamp.now(),
          updatedAt: firebase.firestore.Timestamp.now()
        });
      }
    }

    const showDates = async () => {
      this.setState({
        showDatesCTA: this.state.showDates ? 'Show Dates' : 'Show Time Since',
        showDates: !this.state.showDates,
      });
    }

    const routeToTransactions = () => {
      this.props.history.push(`${this.state.clientId}/transactions`);
    }

    const adminButtons = [pauseButton, teamsAllowedButton, rejectKYCButton];

    if (isRestricted && !isAdmin) {
      return (
        <div className="accountProfile" style={{ height: '100%' }}>
          <PageHeader
            title={`Account Restricted`}
            subTitle={`This Strikepay account has been locked.`}
          />
          <p>Please get in touch with us at <a href={`mailto:support@strikepay.co?subject=Account%20Locked:%20${this.state.clientId}`}>support@strikepay.co</a> if you believe this is an error.</p>
          {
            this.isKycButtonShown() &&
            <Card align='center'>
              <Paragraph style={{ display: 'inline-block', fontSize: '20px', fontWeight: 'bold' }}>We need you to take some additional steps to verify your identity!</Paragraph><br />
              <Space direction='vertical' width={'100%'}>
                {
                  <Button
                    key={'idverification'}
                    icon={<SecurityScanOutlined />}
                    onClick={() => this.navigateToKycVerification()}
                    type={'primary'}
                    style={{ textAlign: 'start', width: `100%` }}
                  >Start Identity Verification</Button>
                }
              </Space>
            </Card>
          }
        </div>
      );
    }

    const { isCompany } = this.state.client || { isCompany: false };

    return (
      <div className="accountProfile" style={{ height: '100%' }}>
        {(this.state.clientNotFound) &&
          (<PageHeader
            ghost={false}
            title={`Account Not Found`}
            subTitle={`Please register`}
          />)
        }
        {(this.state.client && isAdmin) &&
          (<PageHeader
            ghost={false}
            title={this.state.client.displayName ? `${this.state.client.displayName} ${flag} ${teamAccountText}` : `Add Details`}
            subTitle={this.state.client.profileBio ? `${this.state.client.profileBio}` : null}
            avatar={avatarParams}
            extra={adminButtons}
          />)
        }
        {isAdmin && this.state.showPauseReasonModal && (
          <Modal
            title={this.state.client?.isRestricted ? 'Enable client' : 'Pause client'}
            visible={true}
            onOk={() => this.doPauseOrEnable(this.state.pauseReasonValue.trim() || null)}
            onCancel={() => this.setState({ showPauseReasonModal: false, pauseReasonValue: '' })}
            okText={this.state.client?.isRestricted ? 'Enable' : 'Pause'}
            cancelText="Cancel"
          >
            <p>Reason (optional):</p>
            <Input.TextArea
              rows={3}
              placeholder="Enter reason..."
              value={this.state.pauseReasonValue}
              onChange={(e) => this.setState({ pauseReasonValue: e.target.value })}
              autoFocus
            />
          </Modal>
        )}
        {isAdmin && this.state.client && !this.isLoading() && (
          <AdminSourcingBox client={this.state.client} />
        )}
        <AnnouncementsCard isAdmin={isAdmin} />
        {!this.isLoading() && this.state.client ? this.renderStripeAppsPanel() : null}
        <ClientAnnouncementsCard isAdmin={isAdmin} clientId={this.state.clientId} />
        {isAdmin && this.state.client && !this.isLoading() &&
          <AdminChangeHistoryBox clientId={this.state.clientId} />
        }
        {isAdmin && this.state.client && !this.isLoading() &&
          <IDVTable client={this.state.client}/>
        }
        {/* Show connected account only for US clients Stripe Connect */}
        {isAdmin && this.state.client && !this.isLoading() && this.state.client.country === 'US' &&

          <div style={{ paddingBottom: '16px', paddingTop: '8px' }}>
            <Divider orientation='left' >Stripe Connect</Divider>
            <AdminGridClientConnectAccounts clientId={this.state.clientId} isConnect={true} />
            <Divider />
          </div>
        }

        {(this.state.client === null) &&
          (null)
        }
        {<CenteredSpinner loading={this.isLoading()} />}
        
        {/* Phone-only account: offer a free way to log in next time, once. */}
        {!this.isLoading() && this.state.client && !isAdmin && (
          <div style={{ paddingTop: '16px' }}>
            <FasterSigninCard />
            <HomeScreenCard />
          </div>
        )}

        {/* Get paid: only once there is a balance, and only while Stripe still lacks something. */}
        {!this.isLoading() && this.state.client && this.hasAnyBalance() && this.getPayoutErrors().length > 0
          && this.renderCompletionAlert({
            title: 'Add your details to get paid',
            items: this.getPayoutErrors(),
            footerText: 'Tap to add them and set up your bank account',
            page: 'bank',
          })}

        {/* Complete your profile */}
        {!this.isLoading() && this.state.client && !this.state.client.isCompany && this.getProfileErrors().length > 0
          && this.renderCompletionAlert({
            title: 'Complete your profile',
            items: this.getProfileErrors(),
            footerText: 'Click anywhere to complete your profile',
            page: 'profile',
          })}

        {/* Verify/add phone as a login method. Applies to the client account (not the teams
            list). Phone sign-in is new, so most clients don't have it yet — this drives
            adoption and surfaces the Security page. Closable for the session; reappears until
            phone is an actual sign-in method. */}
        {!this.isLoading() && this.state.client && !isAdmin && !phoneIsLoginMethod && (
          <div style={{ padding: isMobile ? '16px 12px' : '16px 16px 8px' }}>
            <Alert
              type="warning"
              showIcon
              closable
              style={{ borderRadius: 6 }}
              message={clientPhone ? 'Verify your phone number' : 'Add your phone number'}
              description={clientPhone
                ? 'Your number is on your profile but isn’t set up as a sign-in method yet. Verify it to sign in with your phone and help secure your account.'
                : 'Add your mobile as a sign-in method so you always have a secure way back into your account.'}
              action={(
                <Button
                  size="small"
                  type="primary"
                  onClick={() => {
                    const securityUrl = this.baseURLs.manage
                      ? `${this.baseURLs.manage}/${this.state.clientId}/security`
                      : `/client/manage/${this.state.clientId}/security`;
                    window.location.href = securityUrl;
                  }}
                >
                  {clientPhone ? 'Verify now' : 'Add phone'}
                </Button>
              )}
            />
          </div>
        )}

        { !this.isClientTypeTeam(clientType) &&
          <LoadableTeamsGrid
            condition={() => {
              return !this.isLoading() && this.state.client != null && this.state.client.teamsAllowed
            }}
            clientId={this.state.clientId}
            client={this.state.client}
            isAdmin={isAdmin}
            locStrings={this.props.locStrings}
          />
        }

        {/* Clients this person runs by delegation — first-class home objects,
            mirroring the teams strip. Renders nothing when there are none. */}
        { !this.isClientTypeTeam(clientType) && this.state.clientId &&
          <DelegatedClientsGrid
            clientId={this.state.clientId}
            isAdmin={isAdmin}
            ownerUid={this.state.client ? this.state.client.ownerId : null}
          />
        }
        {isAdmin && !this.isClientTypeTeam(clientType) && !this.isLoading() && this.state.client && (
          <FormerTeamsSection
            clientId={this.state.clientId}
            baseURLs={this.baseURLs}
            isAdmin={isAdmin}
          />
        )}
        { this.isClientTypeTeam(clientType) && this.state.clientId && this.state.client &&
          <div style={{ paddingBottom: '16px', paddingTop: '16px', maxWidth: '400px', margin: '0 auto' }}>
            <TeamClientTeamCard teamClientId={this.state.clientId} isAdmin={isAdmin} locStrings={this.props.locStrings} />
          </div>
        }
        { 
          <AccountBalancesView
            condition={() => { return !this.state.loadingDetails.client && this.state.client != null }}
            locStrings={this.props.locStrings}
            client={this.state.client}
            clientId={this.state.clientId}
            payouts={this.state.payouts}
            withdrawals={this.state.withdrawals}
            {...this.state}
          />
        }
        <ActionsButtonsCard
          visible={!this.state.loadingDetails.client && this.state.client != null}
          tippingTag={this.state.tippingTag}
          paymentTag={this.state.paymentTag}
          handler={this.handlerActionsButton}
          client={this.state.client}
          clientId={this.state.clientId}
          isAdmin={isAdmin}
        />
        { true && this.state.clientId && this.state.client && this.state.isNewLayout &&
          <>
          <Paragraph style={{ paddingTop: '30px', fontWeight: 'bold' }}>
            {'Current Activity'}
            <Button onClick={routeToTransactions} type="secondary" size="small" style={{ marginLeft: "10px" }}>Downloads</Button>
          </Paragraph>
          <div className='container mx-0 px-0 my-1 py-1'>
            <ProgressCreatingTap clientId={this.state.clientId} isAdmin={this.isAdmin} locStrings={this.locStrings} />
          </div>
          <ClientRecentAvailableActivityList 
            index={this.state.selectedDateRangeIndex}
            clientId={this.state.clientId}
            locStrings={this.props.locStrings}
            client={this.state.client}
            isAdmin={isAdmin}
          />
          </>
        }
        { this.state.clientId && this.state.client &&  
          <BannerAd isAdmin={isAdmin} clientId={this.state.clientId} country={this.state.client.country || 'IE'}/>
        }

        {/* Buy Tipping Stands Section - Only show for salon categories */}
        {!this.isLoading() && this.state.client && (
          <>
            <Divider orientation='left' />
            <BuyTippingStandsSection
              clientId={this.state.clientId}
              client={this.state.client}
              screenWidth={this.state.screenWidth}
              isAdmin={this.isAdmin}
              brand="salonkit"
            />
          </>
        )}

        {isTest ? <>{'AccountProfileScreen'}</> : null}

      </div>
    );
  }
}

